export const ENTITY_FILTERS = [
  'all',
  'pages',
  'tables',
  'views',
  'fields',
  'records',
  'values',
] as const
export type FilterKey = (typeof ENTITY_FILTERS)[number]
export type ResultKind = Exclude<FilterKey, 'all'>

export const FILTER_LABELS: Record<FilterKey, string> = {
  all: 'All',
  pages: 'Pages',
  tables: 'Tables',
  views: 'Views',
  fields: 'Fields',
  records: 'Records',
  values: 'Values',
}

export const VISIBLE_CAP = 3
export const METADATA_PAGE_SIZE = 10
export const METADATA_PREFETCH_BATCHES = 3
export const RECORD_PAGE_SIZE = 20
export const RECORD_PREFETCH_BATCHES = 2
/**
 * Fixed shape for /search/preview/records fetches: batch-aligned offset and a
 * constant limit, so a given window always produces identical, dedupable
 * requests regardless of scroll phase. Variable limits made the same offset
 * fetch twice (e.g. limit 100 and 120) because the in-flight key differed.
 */
export const RECORD_FETCH_BATCH_ROWS = 100
/**
 * Trailing settle for scroll-driven record fetches — a scrollbar scrub or
 * smooth-scroll sweep collapses into the final position's batches instead of
 * firing one request per intermediate scroll event.
 */
export const RECORD_FETCH_DEBOUNCE_MS = 150
export const RESULT_ROW_HEIGHT = 28
export const RESULT_VIRTUAL_WINDOW_ROWS = 48
export const RESULT_VIRTUAL_OVERSCAN_ROWS = 8
